"use client";

import { isComingSoon } from "@/lib/coming-soon";
import { ComingSoonPage } from "@/components/coming-soon-page";
import { LoginForm } from "./login-form";

export default function LoginPage() {
    if (isComingSoon) return <ComingSoonPage />;
    return <LoginForm />;
}
